export const LIST_QUERY_KEYS = ["filter", "sort", "dir", "q", "customerId", "status", "engagementId", "poId", "invoiceId", "billId", "sql"] as const;

export interface RecordStep {
  id: string;
  proposalId?: string;
  quotationId?: string;
}

export function listQueryString(search: string): string {
  const current = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const keep = new URLSearchParams();
  for (const key of LIST_QUERY_KEYS) {
    const value = current.get(key);
    if (value) keep.set(key, value);
  }
  const text = keep.toString();
  return text ? `?${text}` : "";
}

export function withListQuery(to: string, search: string): string {
  const extra = listQueryString(search);
  if (!extra) return to;
  const [path, existing] = to.split("?");
  const params = new URLSearchParams(existing || "");
  new URLSearchParams(extra.slice(1)).forEach((value, key) => {
    if (!params.has(key)) params.set(key, value);
  });
  const text = params.toString();
  return text ? `${path}?${text}` : path;
}

export function stepPath(step: RecordStep, basePath: string, prefer: "proposal" | "quotation" | ""): string {
  if (prefer === "quotation" && step.quotationId) return `/quotations/${step.quotationId}`;
  if (prefer === "proposal" && step.proposalId) return `/proposals/${step.proposalId}`;
  if (step.proposalId) return `/proposals/${step.proposalId}`;
  if (step.quotationId) return `/quotations/${step.quotationId}`;
  return `${basePath}/${step.id}`;
}

function matches(step: RecordStep, currentId: string): boolean {
  return step.id === currentId || step.proposalId === currentId || step.quotationId === currentId;
}

export function neighbors(steps: RecordStep[], currentId: string, basePath: string, prefer: "proposal" | "quotation" | ""): { prev: string; next: string; label: string } | null {
  const index = steps.findIndex((step) => matches(step, currentId));
  if (index < 0) return null;
  const prev = index > 0 ? stepPath(steps[index - 1]!, basePath, prefer) : "";
  const next = index < steps.length - 1 ? stepPath(steps[index + 1]!, basePath, prefer) : "";
  return { prev, next, label: `${index + 1} of ${steps.length}` };
}
